import { type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { ROUTES_CONFIG } from "./routes-config";
import { isRouteMatch } from "./use-is-route-active";
import { retrieveRouteComponentsFromPath } from "./retrieve-route-components-from-path";
import type { RoutesConfig } from "./types";

const findExactRoute = (pathname: string, config: RoutesConfig = ROUTES_CONFIG, basePath = ""): string | null =>
  Object.entries(config).reduce<string | null>((deepest, [route, routeConfig]) => {
    const fullPath = basePath + route;
    if (!isRouteMatch(pathname, fullPath)) return deepest;

    const isExact = fullPath.split("/").filter(Boolean).length === pathname.split("/").filter(Boolean).length;
    const subMatch = routeConfig.subRoutes ? findExactRoute(pathname, routeConfig.subRoutes, fullPath) : null;

    return subMatch ?? (isExact ? fullPath : null) ?? deepest;
  }, null);

export const useActiveTakeoverCard = (): ReactNode | undefined => {
  const { pathname } = useLocation();

  const path = findExactRoute(pathname);
  if (!path) return undefined;

  return retrieveRouteComponentsFromPath(path)?.takeoverCardComponent ?? undefined;
};
